import React from 'react';
import type { Node } from 'react';
import styled from '@emotion/styled';
import isArray from 'lodash/isArray';

import { Alert, Icon, IconButton } from '..';

type Props = {
  type: string,
  text: string,
  bannerId: number,
  isBannerVisible: boolean,
  handleCloseBanner: Function,
};

const types = {
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
};

export const Notification = ({ type, text, bannerId, isBannerVisible, handleCloseBanner }: Props): Node => {
  const fullText = isArray(text) ? text : [text];
  if (!isBannerVisible) return null;

  return (
    <AlertWrapper type={type} size="small" data-test="menu-status-notification">
      <IconWrap name={type === types.DANGER ? 'TimesCircle' : 'InfoCircle'} mr={4} ml="auto" />
      <div>
        {fullText.map(text => (
          <div key={text}>{text}</div>
        ))}
      </div>
      <IconButtonWrapper
        onClick={() => handleCloseBanner(false, bannerId)}
        visible={type !== types.DANGER}
        icon="Times"
        data-test="menu-status-notification-close-button"
        ml="auto"
        mode="ghost"
      />
    </AlertWrapper>
  );
};

const AlertWrapper = styled(Alert)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme, type }) => ([types.DANGER, types.INFO].includes(type) ? theme.color.white : theme.color.black)};
  background-color: ${({ theme, type }) =>
    type === types.INFO ? theme.color.info : type === types.DANGER ? theme.color.danger : theme.color.warning};
  font-size: ${({ theme }) => theme.fontSize.md};
  padding: 16px;
  border-radius: 0;

  @media (${({ theme }) => theme.breakpoint.desktop}) {
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
`;

const IconWrap = styled(Icon)`
  flex-shrink: 0;
  font-size: ${({ theme: { fontSize } }) => fontSize.lg};

  @media (${({ theme: { breakpoint } }) => breakpoint.desktop}) {
    font-size: ${({ theme: { fontSize } }) => fontSize.xxl};
  }
`;

const IconButtonWrapper = styled(IconButton)`
  font-size: ${({ theme: { fontSize } }) => fontSize.lg};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};

  @media (${({ theme: { breakpoint } }) => breakpoint.desktop}) {
    font-size: ${({ theme: { fontSize } }) => fontSize.xxl};
  }
`;

Notification.defaultProps = {
  type: 'warning',
};
